import { getBackendSafeRoomName } from '../util/uri';
const NON_CONFERENCE_PATHS = new Set([
    '/',
    '/asl-ai.html',
    '/captioner-dashboard.html',
    '/captioner-login',
    '/captioner-login.html',
    '/captioner-profile.html',
    '/client',
    '/client-login',
    '/client-login.html',
    '/client-profile.html',
    '/index.html',
    '/interpreter-dashboard.html',
    '/interpreter-jobs.html',
    '/interpreter-login',
    '/interpreter-login.html',
    '/interpreter-profile.html',
    '/interpreter-schedule.html',
    '/ipcts-registration.html',
    '/login',
    '/malkavrs-desktop.html',
    // The interpreter/captioner portal. Without this the SPA reads "provider"
    // off the path and tries to join a conference called provider.
    '/provider',
    '/relay.html',
    '/vri-invite.html',
    '/vri-load-lab.html',
    '/vrs-admin-dashboard.html',
    '/vrs-admin.html',
    '/vrs-welcome.html'
]);
export function getRoomNameFromPath(path) {
    const normalizedPath = path.length > 1 ? path.replace(/\/+$/, '') : path;
    if (NON_CONFERENCE_PATHS.has(normalizedPath)) {
        return undefined;
    }
    const roomName = normalizedPath.substring(normalizedPath.lastIndexOf('/') + 1) || undefined;
    return getBackendSafeRoomName(roomName);
}
/**
 * Builds and returns the room name.
 *
 * @returns {string}
 */
export default function getRoomName() {
    return getRoomNameFromPath(window.location.pathname);
}
